import { ShinyButton } from "@/components/magicui/shiny-button";
 
export function ShinyButtonDemo() {
  return <ShinyButton>Shiny Button</ShinyButton>;
}